import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ConnectedSource {
  id: string;
  name: string;
  type: string;
  active: boolean;
  lastSyncAt: string | null;
  /** ok = active and synced within 48h, warn = active but never/stale, off = inactive */
  status: 'ok' | 'warn' | 'off';
}

const STALE_MS = 48 * 60 * 60 * 1000;

/** Real connection status from integration_configs (tenant-scoped by RLS). Never fabricated. */
export const useConnectedSources = () =>
  useQuery({
    queryKey: ['connected-sources'],
    staleTime: 60_000,
    queryFn: async (): Promise<ConnectedSource[]> => {
      const { data, error } = await supabase
        .from('integration_configs')
        .select('id,name,integration_type,is_active,last_sync_at')
        .order('name');
      if (error) throw error;
      return (data ?? []).map((r) => {
        const fresh = r.last_sync_at && Date.now() - new Date(r.last_sync_at).getTime() < STALE_MS;
        return {
          id: r.id,
          name: r.name || r.integration_type,
          type: r.integration_type,
          active: r.is_active,
          lastSyncAt: r.last_sync_at,
          status: !r.is_active ? 'off' : fresh ? 'ok' : 'warn',
        };
      });
    },
  });
